import { render } from "./Relastats.vue?vue&type=template&id=758573e8&scoped=true"
import script from "./Relastats.vue?vue&type=script&lang=js"
export * from "./Relastats.vue?vue&type=script&lang=js"

import "./Relastats.vue?vue&type=style&index=0&id=758573e8&scoped=true&lang=scss"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-758573e8"]])

export default __exports__